import { cssClass } from '../../style';
import { CommonStyles } from '../../common/react/CommonStyles';

export namespace DraftStyles {
    const cssPrefix = 'Draft';

    export const DraftThumbnailTextStyle = cssClass(cssPrefix, '-thumbnail-text', {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translateX(-50%) translateY(-50%)',
        color: 'white',
    });

    export const DraftTagsContainer = cssClass(cssPrefix, '-tag-container', {
        display: 'flex',
        flexDirection: 'row-reverse',
        flexWrap: 'wrap',
    });

    export const DraftTag = cssClass(cssPrefix, '-tag', {
        margin: '3px',
        fontSize: '13px',
        border: '1px dashed #cccccc',
        borderRadius: '4px',
        padding: '0 8px',
        lineHeight: '30px',
        color: '#666666',
        background: 'rgba(255, 255, 255, 0.7)',
    });
}

export namespace TooltipDraftIndicatorStyles {
    const cssPrefix = 'TooltipDraftIndicator';

    export const ContainerStyle = cssClass(cssPrefix, '-container-style', {
        display: 'flex',
        borderLeft: '4px solid transparent',
        borderColor: CommonStyles.Colors.FocusBorderBlue,
        backgroundColor: CommonStyles.Colors.Grey245,
        padding: '0.5rem',
        marginBottom: '18px',
    });

    export const TextStyle = cssClass(cssPrefix, '-text-style', {
        display: 'inline',
        fontSize: CommonStyles.Sizes.NormalFontSize.toString() + 'px',
        letterSpacing: '0.2px',
        lineHeight: '1.5',
    });

    export const IconStyle = cssClass(cssPrefix, '-icon-style', {
        color: CommonStyles.Colors.FocusBorderBlue,
        marginRight: '4px', verticalAlign: 'top',
        width: CommonStyles.Sizes.SmallIconSize.toString() + 'px',
        height: CommonStyles.Sizes.SmallIconSize.toString() + 'px'
    });
}
